class MobileFilters {
    constructor(el) {
        this.el = el;
        this.opener = document.querySelector(".mobile-filters__open-btn");
        this.closer = el.querySelector(".mobile-filters__close button");
        this.attachHandlers();
    }

    attachHandlers = () => {
        this.opener.addEventListener("click", this.open);
        this.closer.addEventListener("click", this.close);
    };

    open = () => {
        this.el.classList.add("active");
        const body = document.body;
        if (body) {
            body.classList.add("no-scroll");
        }
    };

    close = () => {
        this.el.classList.remove("active");
        const body = document.body;
        if (body) {
            body.classList.remove("no-scroll");
        }
    };
}

const els = document.querySelectorAll(".mobile-filters");
els.forEach(el => {
    new MobileFilters(el);
});
